import { observer } from 'mobx-react-lite';
import React from 'react';
import logo from './rochdale_council_logo.png';

const RCC_LOGO = observer(() => {
  return <img src={logo} alt="Rochdale Borough Council" />;
});

export default RCC_LOGO;
